import React from "react";
import "../../Styles/Seller/Product.css";

export default function ForbiddenSellerMaster() {
  return (
    <div className="mbp-product-page">
      <div className="mbp-product-card">
        <div className="mbp-empty-state">
          <h3>Access restricted</h3>
          <p>You are not allowed to manage product master data.</p>
        </div>
      </div>
    </div>
  );
}
